import { render, staticRenderFns } from "./serviceVersion__form.vue?vue&type=template&id=751bfc36"
import script from "./serviceVersion__form.vue?vue&type=script&lang=js"
export * from "./serviceVersion__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports